import { FETCH_LAUNDRY_CLIENT } from './PointValueActions'

const INITIAL_STATE = {
  laundryClient: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LAUNDRY_CLIENT.SUCCESS:
      return {
        ...state,
        laundryClient: action.payload.data?.data,
      }
    default:
      return state
  }
}
